import './disableConsole';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 기존 콜백 방식(Request.utils) 과 동작을 맞추기 위해 자동 재시도·포커스 재조회는 끈다.
// 캐시 유지 시간(staleTime)은 데이터 성격이 제각각이라 쿼리별로 지정한다.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode 는 개발 모드에서 useEffect 를 두 번 실행해 로컬 확인 시 API 가 중복 호출되어 제외한다.
// 부작용(cleanup 누락 등) 점검이 필요하면 일시적으로 다시 감싸서 확인한다.
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
